export const RELEASE_NOTES_URL = "/release-notes.json";

export function isHistoryEntryExpanded(index, expandedHistoryIndex) {
  return index === 0 || index === expandedHistoryIndex;
}

export function getNextExpandedHistoryIndex(currentIndex, clickedIndex) {
  return currentIndex === clickedIndex ? null : clickedIndex;
}

export const FALLBACK_RELEASE_NOTES = {
  version: "",
  releasedAt: "",
  title: "Neue Version",
  summary: "Diese Version enthält Verbesserungen und Fehlerbehebungen.",
  sections: [
    {
      title: "Verbesserungen",
      items: ["Die App wurde aktualisiert. Lade neu, um die neuesten Änderungen zu verwenden."],
    },
  ],
  history: [],
};

export function normalizeReleaseNoteEntry(raw, fallback = FALLBACK_RELEASE_NOTES) {
  if (!raw || typeof raw !== "object") return fallback;
  const sections = Array.isArray(raw.sections)
    ? raw.sections
        .map((section) => ({
          title: String(section?.title || "").trim() || "Änderungen",
          items: Array.isArray(section?.items)
            ? section.items.map((item) => String(item || "").trim()).filter(Boolean)
            : [],
        }))
        .filter((section) => section.items.length > 0)
    : [];

  return {
    version: String(raw.version || "").trim(),
    title: String(raw.title || "").trim() || fallback.title,
    summary: String(raw.summary || "").trim() || fallback.summary,
    releasedAt: String(raw.releasedAt || "").trim(),
    sections: sections.length > 0 ? sections : fallback.sections,
  };
}

export function normalizeReleaseNotes(raw) {
  const current = normalizeReleaseNoteEntry(raw, FALLBACK_RELEASE_NOTES);
  const history = Array.isArray(raw?.history)
    ? raw.history
        .map((entry) => normalizeReleaseNoteEntry(entry, current))
        .filter((entry) => entry.version || entry.sections.length > 0)
    : [];

  const hasCurrentInHistory = history.some((entry) => (
    entry.version && current.version && entry.version === current.version
  ));

  return {
    ...current,
    history: hasCurrentInHistory ? history : [current, ...history],
  };
}

export async function fetchReleaseNotes() {
  const response = await fetch(`${RELEASE_NOTES_URL}?v=${Date.now()}`, {
    cache: "no-store",
    credentials: "same-origin",
    headers: { "Cache-Control": "no-cache" },
  });
  if (!response.ok) return FALLBACK_RELEASE_NOTES;
  const data = await response.json().catch(() => null);
  return normalizeReleaseNotes(data);
}
